import { defineComponent as _defineComponent } from 'vue';
import TemplateSummary from "./TemplateSummary.vue";
import TemplateSummaryPopover from "@/components/ConfigTemplates/TemplateSummaryPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummaryPopover',
    props: {
        target: null,
        template: null
    },
    setup(__props) {
        return { __sfc: true, TemplateSummary, TemplateSummaryPopover };
    }
});
